import { render, staticRenderFns } from "./new-clue.pug?vue&type=template&id=27988e82&lang=pug&"
import script from "./new-clue.ts?vue&type=script&lang=ts&"
export * from "./new-clue.ts?vue&type=script&lang=ts&"
import style0 from "./new-clue.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports